<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <!-- Audit Num -->
      <div class="form-group col-sm-6">
        <label for="first-name">{{lang?.audit_num}}</label>
        <input type="text" class="form-control" formControlName="audit_no"
          [ngClass]="formErrorClass(createForm.controls.audit_no, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.audit_no?.touched || createFormSubmitted) && createForm.controls.audit_no?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Standard Id -->
      <div class="form-group col-sm-6">
        <label for="first-name">{{lang?.std}}</label>
        <!-- <input type="text" class="form-control" formControlName="standard_id"
          [ngClass]="formErrorClass(createForm.controls.standard_id, createFormSubmitted)"> -->
        <select class="form-control" formControlName="standard_id" (change)="selectStdId($event)">
          <option *ngFor="let std of standards" [value]="std.standard_id"> {{ std.standard_title }} </option>
        </select>
        <span class="text-danger"
          *ngIf="(createForm.controls.standard_id?.touched || createFormSubmitted) && createForm.controls.standard_id?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Description -->
      <div class="form-group col-sm-12">
        <label>{{ lang?.description }}</label>
        <textarea type="text" class="form-control" formControlName="description"
          [ngClass]="formErrorClass(createForm.controls.description, createFormSubmitted)"></textarea>
        <span class="text-danger"
          *ngIf="(createForm.controls.description?.touched || createFormSubmitted) && createForm.controls.description?.errors?.required">
          This field is required.
        </span>
      </div>

      <div formArrayName="auditorArr">
        <div *ngFor="let item of getControls(); let i = index;" [formGroupName]="i">
          <!-- Auditor -->
          <div class="form-group col-sm-5">
            <label for="first-name">{{lang?.auditor}}</label>
            <input type="text" class="form-control" formControlName="auditor">
            <span class="text-danger"
              *ngIf="(item.controls.auditor?.touched || createFormSubmitted) && item.controls.auditor?.errors?.required">
              This field is required.
            </span>
          </div>

          <!-- Function -->
          <div class="form-group col-sm-5">
            <label for="first-name">{{lang?.function}}</label>
            <input type="text" class="form-control" formControlName="function">
            <span class="text-danger"
              *ngIf="(item.controls.function?.touched || itemSubmitted) && item.controls.function?.errors?.required">
              This field is required.
            </span>
          </div>

          <div class="form-group col-sm-2">
            <a *ngIf="i <= 0" class="audit-action" (click)="addItem()"> <i class="fa fa-plus"></i> </a>
            <a *ngIf="i >= 1" class="audit-action" (click)="removeItem(i)"> <i class="fa fa-trash"></i> </a>
          </div>     
        </div>
 
      </div>

      <!-- notes -->
      <div class="form-group col-sm-12">
        <label>{{ lang?.notes }}</label>
        <textarea type="text" class="form-control" formControlName="notes"
          [ngClass]="formErrorClass(createForm.controls.notes, createFormSubmitted)"></textarea>
        <span class="text-danger"
          *ngIf="(createForm.controls.notes?.touched || createFormSubmitted) && createForm.controls.notes?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Company -->
      <div class="form-group col-sm-6">
        <label for="first-name">{{lang?.company}}</label>
        <input type="text" class="form-control" formControlName="company"
          [ngClass]="formErrorClass(createForm.controls.company, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.company?.touched || createFormSubmitted) && createForm.controls.company?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Company Address -->
      <div class="form-group col-sm-6">
        <label for="first-name">{{lang?.address}}</label>
        <input type="text" class="form-control" formControlName="company_address"
          [ngClass]="formErrorClass(createForm.controls.company_address, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.company_address?.touched || createFormSubmitted) && createForm.controls.company_address?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Company -->
      <div class="form-group col-sm-6">
        <label for="first-name">{{lang?.company_contact}}</label>
        <input type="text" class="form-control" formControlName="company_contact"
          [ngClass]="formErrorClass(createForm.controls.company_contact, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.company_contact?.touched || createFormSubmitted) && createForm.controls.company_contact?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Company Address -->
      <div class="form-group col-sm-6">
        <label for="first-name">{{lang?.iaf_main}}</label>
        <input type="text" class="form-control" formControlName="iaf_main"
          [ngClass]="formErrorClass(createForm.controls.iaf_main, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.iaf_main?.touched || createFormSubmitted) && createForm.controls.iaf_main?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Scope of the certificate -->
      <div class="form-group col-sm-12">
        <label>{{ lang?.scope_of_cert }}</label>
        <textarea type="text" class="form-control" formControlName="scope_cert"
          [ngClass]="formErrorClass(createForm.controls.scope_cert, createFormSubmitted)"></textarea>
        <span class="text-danger"
          *ngIf="(createForm.controls.scope_cert?.touched || createFormSubmitted) && createForm.controls.scope_cert?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Start Date -->
      <div class="form-group col-sm-6">
        <label for="first-name">{{lang?.start_date}}</label>
        <input type="date"  class="form-control" formControlName="start_date" [(ngModel)]="start_date"
          [ngClass]="formErrorClass(createForm.controls.start_date, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.start_date?.touched || createFormSubmitted) && createForm.controls.start_date?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- End Date -->
      <div class="form-group col-sm-6">
        <label for="first-name">{{lang?.end_date}}</label>
        <input type="date"  class="form-control" formControlName="end_date" [(ngModel)]="start_date"
          [ngClass]="formErrorClass(createForm.controls.end_date, createFormSubmitted)">
        <span class="text-danger"
          *ngIf="(createForm.controls.end_date?.touched || createFormSubmitted) && createForm.controls.end_date?.errors?.required">
          This field is required.
        </span>
      </div>

      <!-- Standard Clause Audited -->
      <div class="form-group col-sm-12">
        <label>{{ lang?.std_clause_audited }}</label>
        <ng-multiselect-dropdown formControlName="chapter_id" [settings]="dropdownSettings" [data]="dropdownList">
        </ng-multiselect-dropdown>          
        <span class="text-danger"
          *ngIf="(createForm.controls.chapter_id?.touched || createFormSubmitted) && createForm.controls.chapter_id?.errors?.required">
          This field is required.
        </span>
      </div>


    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ lang?.save }}</button>
    <!-- <button class="btn btn-warning" data-dismiss="modal" (click)="bsModalRef.hide()">Close</button> -->
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang?.close }}</button>

  </div>
</form>